import { render, staticRenderFns } from "./normal-desc-text.vue?vue&type=template&id=778a9d25&"
import script from "./normal-desc-text.vue?vue&type=script&lang=js&"
export * from "./normal-desc-text.vue?vue&type=script&lang=js&"
import style0 from "./normal-desc-text.vue?vue&type=style&index=0&id=778a9d25&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports